import { render } from "./BalansirPage.vue?vue&type=template&id=379e9ef8&scoped=true"
import script from "./BalansirPage.vue?vue&type=script&lang=js"
export * from "./BalansirPage.vue?vue&type=script&lang=js"

import "./BalansirPage.vue?vue&type=style&index=0&id=379e9ef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379e9ef8"]])

export default __exports__